import { Box } from '@mui/material';
import { ReactNode } from 'react';

export interface AuthContainerProps {
  children: ReactNode;
  component?: 'form' | 'div';
  onSubmit?: (e?: React.BaseSyntheticEvent) => Promise<unknown>;
}

export function AuthContainer({
  children,
  component = 'div',
  onSubmit,
}: AuthContainerProps) {
  return (
    <Box
      component={component}
      onSubmit={onSubmit}
      sx={{
        width: '100%',
        mt: 3,
        gap: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {children}
    </Box>
  );
}
